<template>
	<div class="ks-videoeditor-inspector-body">
		<k-text-field label="Title" :value="audio.title" @input="update({title: $event})"></k-text-field>
		<div class="ks-videoeditor-inline">
			<k-text-field label="Start (s)" type="number" :value="round(audio.start)" @input="set_start"></k-text-field>
			<k-text-field label="Duration (s)" type="number" :value="round(audio.duration)" @input="set_duration"></k-text-field>
		</div>
		<div class="ks-videoeditor-inline">
			<k-text-field label="Source offset (s)" type="number" :value="round(audio.in)" @input="set_in"></k-text-field>
		</div>
		<div class="ks-videoeditor-meta">Ends at {{ fmt(audio.start + audio.duration) }} / source {{ fmt(audio.source_duration) }}</div>
		<div class="ks-videoeditor-inspector-title">Volume</div>
		<slider-field :value="audio.volume" @input="update({volume: $event})"></slider-field>
		<div class="ks-videoeditor-inline ks-videoeditor-actions">
			<k-btn size="s" icon icon-name="my_location" @click="$emit('start-at-playhead', audio)">Start at playhead</k-btn>
			<k-btn size="s" icon icon-name="content_copy" @click="$emit('duplicate-audio', audio)"></k-btn>
			<k-btn size="s" color="error" icon icon-name="delete" @click="$emit('remove-audio', audio)"></k-btn>
		</div>
	</div>
</template>

<script>
import {MIN_LEN} from './constants.js'
import SliderField from './SliderField.vue'
import {fmt, round} from './utils.js'

// Properties of an audio item; changes are emitted as update(item, patch)
export default {
	components: {SliderField},
	props: {
		audio: Object
	},
	methods: {
		fmt,
		round,
		update (patch) {
			this.$emit("update", this.audio, patch);
		},
		set_start (value) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.update({start: Math.max(0, v)});
		},
		set_in (value) {
			const v = parseFloat(value);
			if (isNaN(v)) return;
			const a = this.audio;
			const offset = _.clamp(v, 0, a.source_duration - MIN_LEN);
			this.update({in: offset, duration: Math.min(a.duration, a.source_duration - offset)});
		},
		set_duration (value) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.update({duration: _.clamp(v, MIN_LEN, this.audio.source_duration - this.audio.in)});
		}
	}
}
</script>
